import { EntityBase, PaginationRequest } from "./common";

export enum InvestmentMatchReviewFamily {
  CompanyLike = 1,
  Industry = 2,
}

export enum InvestmentReportDatasetType {
  IndustrySummary = 1,
  ListedPortfolio = 3,
  UnlistedPortfolio = 4,
  AcquiredShares = 5,
  DisposedShares = 6,
  DividendIncome = 7,
}

export enum InvestmentMatchReviewTargetKind {
  Company = 1,
  OtherCompany = 2,
  Industry = 3,
}

export interface InvestmentMatchReviewRequest extends PaginationRequest {
  investmentReportId?: number;
  search?: string;
  family?: InvestmentMatchReviewFamily;
  datasetType?: InvestmentReportDatasetType;
  isUnlistedOnly?: boolean;
  includeUnmatched: boolean;
  includeNeedsReview: boolean;
}

export interface InvestmentMatchReviewGroupDto {
  family: InvestmentMatchReviewFamily;
  normalizedTitle: string;
  occurrenceCount: number;
  reportCount: number;
  unmatchedCount: number;
  needsReviewCount: number;
  isUnlistedOnly: boolean;
  datasetTypes: InvestmentReportDatasetType[];
  sampleSourceTitles: string[];
  sampleReportIds: number[];
}

export interface InvestmentMatchReviewGroup extends EntityBase, InvestmentMatchReviewGroupDto {
  id: string;
}

export interface InvestmentMatchReviewQueueSummary {
  occurrenceCount: number;
  groupCount: number;
  unmatchedOccurrenceCount: number;
  needsReviewOccurrenceCount: number;
  companyLikeGroupCount: number;
  industryGroupCount: number;
  unlistedOnlyCompanyGroupCount: number;
}

export interface InvestmentMatchReviewTargetSearchRequest {
  family: InvestmentMatchReviewFamily;
  search: string;
  maxResults?: number;
}

export interface InvestmentMatchReviewTarget {
  kind: InvestmentMatchReviewTargetKind;
  id: number;
  name: string;
  secondaryName?: string;
  normalizedName: string;
  isExactNormalizedMatch: boolean;
  isCompactMatch: boolean;
}

export interface InvestmentMatchReviewTargetSearchResult {
  searchKey: string;
  targets: InvestmentMatchReviewTarget[];
}

export interface InvestmentMatchReviewResolutionRequest {
  family: InvestmentMatchReviewFamily;
  normalizedTitle: string;
  targetKind: InvestmentMatchReviewTargetKind;
  targetId: number;
  expectedOccurrenceCount?: number;
}

export interface InvestmentMatchReviewResolutionResult {
  family: InvestmentMatchReviewFamily;
  normalizedTitle: string;
  targetKind: InvestmentMatchReviewTargetKind;
  targetId: number;
  targetName: string;
  updatedOccurrenceCount: number;
  aliasCreated: boolean;
  aliasId?: number;
  aliasName?: string;
}

export interface InvestmentMatchReviewCreateOtherCompanyRequest {
  family: InvestmentMatchReviewFamily;
  normalizedTitle: string;
  canonicalName: string;
  industryId?: number;
  expectedOccurrenceCount?: number;
}

export interface InvestmentMatchReviewCreateOtherCompanyResult {
  normalizedTitle: string;
  otherCompanyId: number;
  otherCompanyName: string;
  updatedOccurrenceCount: number;
  investedByCompanyCount: number;
  industryId?: number;
}

export interface InvestmentMatchReviewIgnoreRequest {
  family: InvestmentMatchReviewFamily;
  normalizedTitle: string;
  expectedOccurrenceCount?: number;
  reason?: string;
}

export interface InvestmentMatchReviewIgnoreResult {
  family: InvestmentMatchReviewFamily;
  normalizedTitle: string;
  ruleId: number;
  ruleCreated: boolean;
  updatedOccurrenceCount: number;
}
